<template>
    <dropdown :options="options"
              :selected-id="selectedId"
              selected-display-text-field="displayText"
              @dropdownSelectedItemChanged="dateRangeChanged"
              :height="25"
              display-field="displayText">
        <div slot="icon" class="iconSlot">
            <IconBase width="12" height="12" :icon-color="consts.COLORS.LIGHT_800"
                      icon-name="calenderIcon" class="calendarIcon"/>
        </div>
    </dropdown>
</template>

<script>
import dropdown from 'components/dropdowns/Dropdown.vue';
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import mediationManagementConsts from '../../consts';

export default {
    name: 'DateRangeStatisticsDropdown',
    components: {
        dropdown,
        IconBase
    },
    data() {
        return {
            options: mediationManagementConsts.datesOptions,
            consts
        };
    },
    props: {
        selectedId: {
            type: Number
        }
    },
    methods: {
        dateRangeChanged(item) {
            this.$emit('dateRangeChanged', item);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    .iconSlot {
        display: inherit;
        margin-right: 5px;
        vertical-align: middle;
    }

    .dropdown {
        @include font(7);
        background-color: $light-200;
        border-radius: 4px;
        width: 148px;
        background-image: none;
        border: none;
    }

    .dropdownArea {
        top: 22px;
    }

    .calendarIcon {
        padding-right: 5px;
    }
</style>
